import type React from 'react';
import { Box, Icon, Paragraph, Text } from '@zillow/constellation-10';

type BenefitSectionProps = {
  icon: React.ReactNode;
  title: string;
  description: string;
};

const BenefitSection = ({ icon, title, description }: BenefitSectionProps) => {
  return (
    <Box css={{ display: 'flex', alignItems: 'flex-start', gap: 'default' }}>
      <Icon size="md">{icon}</Icon>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'tighter' }}>
        <Text textStyle="body-bold">{title}</Text>
        <Paragraph>{description}</Paragraph>
      </Box>
    </Box>
  );
};

export default BenefitSection;
